<template>
    <div v-if="params.data" class="flex gap-2">
        <span v-if="vatOption && vatOption.id > 1" :class="{'line-through text-error': params.data?.deleted}">
            {{ vatOption?.code + '(' + formatPercentage(vatOption?.displayedRate) + ')' }} 
        </span>
        <span v-else />
    </div>
</template>

<script setup lang="ts">

import { useVatService } from '@/vat/vat.service'
import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'

const {getVatOptionById} = useVatService()

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const vatOption = computed(() => {
    return getVatOptionById(props.params.data.vatOptionId)
})

const formatPercentage = (fraction: number, decimals = 2, postfix = '%', minimumFractionDigits = 0) => {
    const formatted = new Intl.NumberFormat('no', {
        minimumFractionDigits,
        maximumFractionDigits: decimals
    }).format(fraction * 100)
    return formatted + postfix
}

</script>

<style scoped>

</style>